import React from 'react';

const mainColor = '#4299e1';

const SvgCharts = () => (
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 512 512" enableBackground="new 0 0 512 512">
<rect x="10" y="256" fill="#D1C584" width="492" height="246"/>
<path fill="#30995B" d="M416.69,252.891c1.958-3.082,3.585-6.396,4.83-9.891c3.037,0.582,6.169,0.898,9.375,0.898
	c27.344,0,49.51-22.167,49.51-49.511c0-23.155-15.897-42.592-37.37-48.006c6.139-8.246,9.774-18.466,9.774-29.536
	c0-27.344-22.167-49.511-49.511-49.511c-11.143,0-21.425,3.683-29.699,9.896c-10.458-9.276-24.213-14.918-39.291-14.918
	c-3.558,0-7.037,0.331-10.422,0.932c-6.81-30.011-33.626-53.198-65.685-53.198c-29.322,0-54.257,18.74-63.512,44.892
	c-4.343-0.879-8.835-1.344-13.437-1.344c-31.279,0-57.58,21.318-65.165,50.218v147.213L416.69,252.891z"/>
<g>
	<polygon fill="#ACD670" points="353.668,113.605 343.434,168.566 351.999,256 379.113,118.839 	"/>
	<polygon fill="#ACD670" points="400.128,162.176 345.342,252.892 379.113,253.501 429.284,181.579 	"/>
	<rect x="317.24" y="139.31" fill="#ACD670" width="25.878" height="116.69"/>
	<rect x="69.16" y="10" fill="#ACD670" width="24" height="84.58"/>
</g>
<path fill="#EF7159" d="M138.517,256c5.449-20.01,10.234-38.853,13.699-54.451c3.609-16.247,5.784-28.974,5.784-35.834
	c0-37.929-33.131-68.677-74-68.677s-74,30.748-74,68.677c0,13.447,8.359,49.434,19.483,90.286h109.034V256z"/>
<path fill="#ACD670" d="M254,256c0-35.346-28.654-64-64-64s-64,28.654-64,64H254z"/>
<path fill="#FFC943" d="M298.617,211.059c0-35.346-28.654-64-64-64c-28.88,0-53.291,19.128-61.257,45.406
	c0,0,68.057-2.994,78.682,47.77C270,203.667,298.617,211.059,298.617,211.059z"/>
<path fill="#A766B2" d="M317.788,256.127c1.422-3.721,2.212-7.769,2.212-12.009c0-18.16-14.327-32.882-32-32.882
	s-32,14.722-32,32.882c0,4.24,0.789,8.288,2.212,12.009H317.788z"/>
<path d="M70.127,453.096l-0.092-0.07c-4.384-3.357-10.66-2.527-14.02,1.858c-3.358,4.384-2.526,10.661,1.857,14.02l0.092,0.07
	c1.814,1.39,3.952,2.062,6.074,2.062c3.005,0,5.977-1.35,7.945-3.92C75.343,462.731,74.511,456.455,70.127,453.096z"/>
<path d="M70.127,371.096l-0.092-0.07c-4.384-3.357-10.66-2.527-14.02,1.858c-3.358,4.384-2.526,10.661,1.857,14.02l0.092,0.07
	c1.814,1.39,3.952,2.062,6.074,2.062c3.005,0,5.977-1.35,7.945-3.92C75.343,380.731,74.511,374.455,70.127,371.096z"/>
<path d="M70.127,289.096l-0.092-0.07c-4.384-3.357-10.66-2.527-14.02,1.858c-3.358,4.384-2.526,10.661,1.857,14.02l0.092,0.07
	c1.814,1.39,3.952,2.062,6.074,2.062c3.005,0,5.977-1.35,7.945-3.92C75.343,298.731,74.511,292.455,70.127,289.096z"/>
<path d="M454.04,453.065l-0.093-0.07c-4.402-3.336-10.674-2.472-14.01,1.93c-3.336,4.401-2.472,10.674,1.93,14.01l0.093,0.07
	c1.807,1.369,3.928,2.031,6.032,2.031c3.023,0,6.011-1.365,7.978-3.96C459.306,462.674,458.441,456.401,454.04,453.065z"/>
<path d="M441.867,386.935l0.093,0.07c1.807,1.369,3.928,2.031,6.032,2.031c3.023,0,6.011-1.365,7.978-3.96
	c3.336-4.401,2.472-10.674-1.93-14.01l-0.093-0.07c-4.402-3.336-10.674-2.472-14.01,1.93
	C436.602,377.326,437.466,383.599,441.867,386.935z"/>
<path d="M441.867,304.935l0.093,0.07c1.807,1.369,3.928,2.031,6.032,2.031c3.023,0,6.011-1.365,7.978-3.96
	c3.336-4.401,2.472-10.674-1.93-14.01l-0.093-0.07c-4.402-3.336-10.674-2.472-14.01,1.93S437.466,301.599,441.867,304.935z"/>
<path d="M369.342,348h0.13c5.522,0,10-4.477,10-10s-4.478-10-10-10h-0.13c-5.522,0-10,4.477-10,10S363.819,348,369.342,348z"/>
<path d="M142.658,410h-0.13c-5.522,0-10,4.477-10,10s4.478,10,10,10h0.13c5.522,0,10-4.477,10-10S148.181,410,142.658,410z"/>
<path d="M73.72,182.26c-2.63,0-5.21,1.07-7.07,2.93c-1.859,1.86-2.93,4.44-2.93,7.08c0,2.63,1.07,5.2,2.93,7.06
	c1.86,1.87,4.431,2.93,7.07,2.93c2.63,0,5.21-1.06,7.07-2.93c1.859-1.86,2.93-4.43,2.93-7.06c0-2.64-1.07-5.21-2.93-7.08
	C78.93,183.33,76.35,182.26,73.72,182.26z"/>
<path d="M502,246h-41.534c17.872-10.28,29.941-29.556,29.941-51.611c0-22.896-12.99-43.277-32.78-53.194
	c3.414-7.59,5.185-15.833,5.185-24.348c0-32.814-26.696-59.511-59.511-59.511c-10.346,0-20.282,2.61-29.137,7.605
	c-11.618-8.188-25.511-12.627-39.854-12.627c-0.973,0-1.938,0.034-2.902,0.074c-10.565-30.798-40.025-52.34-73.205-52.34
	c-29.92,0-56.994,17.329-69.75,43.882c-2.393-0.222-4.797-0.334-7.199-0.334c-31.445,0-59.373,18.989-71.297,47.304
	c-2.116-0.646-4.269-1.21-6.454-1.699c1.146-12.781,5.2-22.579,12.117-29.167c6.025-5.739,12.077-6.928,12.332-6.976l-0.139,0.023
	l-0.002-0.011c2.114-0.311,4.115-1.286,5.634-2.812c1.859-1.86,2.93-4.43,2.93-7.06c0-2.64-1.07-5.21-2.93-7.08
	c-1.86-1.86-4.44-2.93-7.07-2.93c-0.561,0-1.118,0.059-1.668,0.153l-0.003-0.017c-5.938,0.935-14.059,4.263-21.549,11.025V10
	c0-5.523-4.478-10-10-10h-24c-5.522,0-10,4.477-10,10v37.391C47.651,33.292,35.232,25.05,34.269,24.421
	c-4.619-3.013-10.797-1.711-13.818,2.901c-3.022,4.613-1.731,10.808,2.875,13.839c0.331,0.217,30.586,20.477,35.081,49.622
	C24.568,100.948,0,130.689,0,165.714C0,180.266,8.299,215.208,16.444,246H10c-5.522,0-10,4.477-10,10v246c0,5.523,4.478,10,10,10
	h492c5.522,0,10-4.477,10-10V256C512,250.477,507.522,246,502,246z M181.254,63.596c3.847,0,7.699,0.385,11.452,1.145
	c4.884,0.988,9.749-1.767,11.411-6.465c8.093-22.865,29.828-38.228,54.086-38.228c23.64,0,44.737,14.739,53.3,36.142
	c-27.011,9.451-46.445,35.178-46.445,65.374c0,5.523,4.478,10,10,10s10-4.477,10-10c0-27.157,22.094-49.25,49.251-49.25
	c12.043,0,23.641,4.403,32.655,12.399c3.555,3.153,8.84,3.368,12.64,0.516c6.877-5.164,15.071-7.893,23.695-7.893
	c21.786,0,39.511,17.725,39.511,39.511c0,8.565-2.695,16.714-7.796,23.564c-1.994,2.679-2.52,6.178-1.399,9.325
	s3.737,5.527,6.977,6.344c17.554,4.426,29.814,20.179,29.814,38.309c0,21.786-17.725,39.511-39.511,39.511
	c-2.482,0-5.002-0.242-7.491-0.719c-4.847-0.932-9.646,1.816-11.304,6.464c-0.783,2.197-1.774,4.324-2.939,6.355h-12.624
	l40.949-58.7c1.539-2.206,2.124-4.94,1.623-7.583s-2.046-4.973-4.285-6.463l-29.155-19.402c-2.271-1.512-5.063-2.031-7.724-1.434
	c-2.662,0.596-4.966,2.253-6.376,4.589l-14.579,24.14l11.934-60.369c1.064-5.389-2.416-10.628-7.796-11.734l-25.445-5.233
	c-2.629-0.542-5.367-0.002-7.595,1.496s-3.76,3.829-4.251,6.468l-3.265,17.535h-23.337c-5.522,0-10,4.477-10,10v57.544
	c-6.646-34.029-36.673-59.794-72.617-59.794c-16.197,0-31.581,5.139-44.487,14.862c-10.643,8.017-19.002,18.929-24.032,31.197
	c1.274-7.51,1.902-13.27,1.902-17.404c0-13.561-3.683-26.332-10.16-37.482c5.254-14.295,18.913-24.006,34.363-24.006
	c2.455,0,4.915,0.247,7.313,0.733c4.887,0.994,9.759-1.769,11.418-6.472c2.146-6.078,5.88-11.515,10.8-15.723
	c4.196-3.59,4.688-9.903,1.098-14.1c-3.589-4.197-9.901-4.688-14.1-1.099c-5.494,4.7-10.03,10.398-13.373,16.749
	c-1.051-0.059-2.104-0.088-3.155-0.088c-19.904,0-37.884,10.42-48.028,26.672c-4.75-4.573-10.082-8.608-15.891-11.998
	C137.066,77.779,157.846,63.596,181.254,63.596z M365.622,238.655l37.666-62.365l11.947,7.951L372.153,246h-7.983L365.622,238.655z
	 M353.113,198.797V171.03c0.053-0.21,0.111-0.418,0.151-0.634l8.369-44.944l5.745,1.182L353.113,198.797z M327.163,228.653
	c0.043-0.379,0.072-0.763,0.072-1.153v-78.191h5.879V246h-3.156c0.027-0.626,0.042-1.253,0.042-1.882
	C330,238.667,328.988,233.455,327.163,228.653z M190,182c-0.296,0-0.587,0.019-0.883,0.022c9.777-15.18,26.909-24.963,45.5-24.963
	c26.422,0,48.458,19.081,53.09,44.184c-13.837,0.098-26.099,7.061-33.687,17.714C241.199,196.885,217.313,182,190,182z M243.057,246
	h-104.54h-1.573c4.705-25.012,26.699-44,53.057-44S238.352,220.988,243.057,246z M288,221.236c12.131,0,22,10.265,22,22.882
	c0,0.631-0.03,1.258-0.079,1.882h-43.843c-0.049-0.624-0.079-1.251-0.079-1.882C266,231.501,275.869,221.236,288,221.236z
	 M79.155,20h4v67.057c-1.341,0.013-2.675,0.049-4,0.12V20z M20.597,157.81c0.624,0.122,1.268,0.19,1.927,0.19h49.438
	c5.522,0,10-4.477,10-10s-4.478-10-10-10H27.606c10.81-18.415,32.031-30.963,56.394-30.963c35.29,0,64,26.322,64,58.677
	c0,2.609-0.417,7.423-2.006,16.286h-39.719c-5.522,0-10,4.477-10,10s4.478,10,10,10h33.206c-12.133,11.359-20.442,26.74-22.786,44
	H37.141C26.216,205.214,20,176.152,20,165.714C20,163.033,20.215,160.398,20.597,157.81z M492,328h-88c-5.522,0-10,4.477-10,10
	s4.478,10,10,10h88v62H176.606c-5.522,0-10,4.477-10,10s4.478,10,10,10H492v62H20v-62h88c5.522,0,10-4.477,10-10s-4.478-10-10-10H20
	v-62h315.394c5.522,0,10-4.477,10-10s-4.478-10-10-10H20v-62h9.483H492V328z"/>
<path d="M245.333,74h0.132c5.522,0,10-4.477,10-10s-4.478-10-10-10h-0.132c-5.522,0-10,4.477-10,10S239.811,74,245.333,74z"/>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>

);

export default SvgCharts;
